module.exports = __webpack_public_path__ + "media/4.b1fdefb2.mp3";